/**
 * Map GET /api/background-presets response to UI shapes.
 */

export function mapAssetForPicker(asset) {
  const thumb = asset?.thumb_url || asset?.full_url || "";
  const full = asset?.full_url || asset?.thumb_url || "";
  const source = asset?.source || "owned";
  return {
    id: asset?.slug || String(asset?.id),
    image: thumb,
    full_url: full,
    title: asset?.title,
    is_premium: Boolean(asset?.is_premium),
    source,
    external_asset_id: asset?.external_asset_id ?? null,
    provider_asset_id: asset?.provider_asset_id ?? null,
    photographer: asset?.photographer || null,
    photographer_url: asset?.photographer_url || null,
    photo_url: asset?.photo_url || null,
    attribution: asset?.attribution || null,
    blur_hash: asset?.blur_hash || null,
    color: asset?.color || null,
    download_location: asset?.download_location || null,
    width: asset?.width ?? null,
    height: asset?.height ?? null,
    orientation: asset?.orientation || null,
  };
}

/** Image tab: [{ sectionTitle, groups: [{ name, images }] }] */
export function mapImageCatalogToSections(apiData) {
  if (!Array.isArray(apiData)) return [];
  return apiData.map((main) => ({
    sectionTitle: main.main_category_name,
    groups: (main.subcategories || []).map((sub) => ({
      name: sub.sub_category_name,
      images: (sub.assets || []).map(mapAssetForPicker),
    })),
  }));
}

/** AI tab: { [categoryName]: [{ id, label, image, full_url }] } */
export function mapAiCatalogToPresetCategories(apiData) {
  if (!Array.isArray(apiData)) return {};
  const out = {};
  for (const main of apiData) {
    const sub = (main.subcategories || [])[0];
    if (!sub) continue;
    const categoryName = main.main_category_name;
    out[categoryName] = (sub.assets || []).map((asset) => {
      const mapped = mapAssetForPicker(asset);
      return {
        id: mapped.id,
        label: asset.title || mapped.id,
        image: mapped.image,
        full_url: mapped.full_url,
        is_premium: mapped.is_premium,
      };
    });
  }
  return out;
}
